module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pm-7582c30f04bd66a4e73cc3975398f85d.svg";